<template>
    <div class="about">
      <h2>Acerca de</h2>
      <p>{{ description }}</p>
      <ul>
        <li><strong>Versión:</strong> {{ version }}</li>
        <li><strong>Autor:</strong> {{ author }}</li>
        <li><strong>Contacto:</strong> <a :href="`mailto:${email}`">{{ email }}</a></li>
        <li><strong>Sitio Web:</strong> <a :href="website" target="_blank">{{ website }}</a></li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AcercaDe',
    data() {
      return {
        version: '1.0.0',
        author: 'Nombre del Autor o de la Organización',
        description: 'Esta es una aplicación diseñada para mostrar información relevante sobre el proyecto, su propósito y cómo usarlo.',
        email: 'contacto@ejemplo.com',
        website: 'http://www.ejemplo.com'
      };
    }
  };
  </script>
  
  <style scoped>
  .about {
    margin: 20px auto;
    padding: 20px;
    max-width: 800px;
    background: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
  
  .about h2 {
    color: #2c3e50;
    margin-bottom: 15px;
  }
  
  .about p {
    font-size: 1.1em;
    margin-bottom: 20px;
  }
  
  .about ul {
    list-style: none;
    padding: 0;
  }
  
  .about li {
    margin-bottom: 10px;
    font-size: 1em;
  }
  
  .about a {
    color: #3498db;
    text-decoration: none;
  }
  
  .about a:hover {
    text-decoration: underline;
  }
  </style>  